import { useLocale } from '../../context';

export default function LoginRejected({ onCancel, onRetry, loading }) {
  const _locale = useLocale();
  const tr = _locale.t;

  return (
    <div className="auth-rejected">
      <div className="auth-rejected__box">
        <span className="auth-rejected__title">{tr('auth.verify.expiredTitle')}</span>
        <div className="auth-rejected__actions">
          <button type="button" className="auth-rejected__cancel" disabled={loading} onClick={onCancel}>
            {tr('auth.verify.cancel')}
          </button>
          <button type="button" className="auth-rejected__retry" disabled={loading} onClick={onRetry}>
            {loading ? '...' : tr('auth.verify.retry')}
          </button>
        </div>
      </div>
    </div>
  );
}
